import { configureStore } from '@reduxjs/toolkit';
import productSlice from './slices/productSlice';
import bannerSlice from './slices/bannerSlice';
import testimonialSlice from './slices/testimonialSlice';
import brandSlice from './slices/brandSlice';
import wishlistSlice from './slices/wishlistSlice';
import homeSlice from './slices/homeSlice';
import categorySlice from './slices/categorySlice';
import productListingSlice from './slices/productListingSlice';
import productDetailSlice from './slices/productDetailSlice';
import cartSlice from './slices/cartSlice';
import checkoutSlice from './slices/checkoutSlice';
import userSlice from './slices/userSlice';
import orderSlice from './slices/orderSlice';
import trackOrderSlice from './slices/trackOrderSlice';
import authSlice from './slices/authSlice';
import searchSlice from './slices/searchSlice';
import logoSlice from './slices/logoSlice';
import footerSlice from './slices/footerSlice';

export const store = configureStore({
    reducer: {
        products: productSlice,
        banner: bannerSlice,
        testimonial: testimonialSlice,
        brand: brandSlice,
        wishlist: wishlistSlice,
        home: homeSlice, 
        category: categorySlice, 
        productListing : productListingSlice,
        productDetail: productDetailSlice, 
        cart: cartSlice,  
        checkout: checkoutSlice,  
        user : userSlice,  
        order : orderSlice,  
        trackOrder : trackOrderSlice,  
        trackOrder : trackOrderSlice,  
        auth : authSlice,  
        search: searchSlice,
        logo: logoSlice,
        footer: footerSlice,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});